import { ButtonIcon, Gray100, typeCompact20DisplayProperties, typeCompact24DisplayProperties } from '@traceair/tds';
import { MenuIcon } from '@traceair/webapp-icons';
import { classes, extend, media, stylesheet } from 'typestyle';
import { BREAKPOINT_MEDIUM, BREAKPOINT_SMALL, MOBILE_CONTAINER_PADDINGS } from '../styles';
import { useUiStore } from '../../../store/uiStore';
import React from 'react';

const css = stylesheet({
  container: extend(
    {
      display: 'flex',
      width: '100%',
      padding: '24px 20px 24px 32px',
      alignItems: 'center',
      flex: '0 1 auto',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
    media({ maxWidth: BREAKPOINT_SMALL }, { ...MOBILE_CONTAINER_PADDINGS }),
  ),
  menuToggler: {
    display: 'none',
    marginRight: 8,
    ...media(
      { maxWidth: BREAKPOINT_MEDIUM },
      {
        display: 'inline-flex',
      },
    ),
  },
  heading: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 42,
    margin: 0,
    padding: 0,
    ...typeCompact24DisplayProperties,
    ...media(
      { maxWidth: BREAKPOINT_MEDIUM },
      {
        ...typeCompact20DisplayProperties,
        minHeight: 'auto',
        display: 'block',
      },
    ),
  },
  subheading: {
    color: Gray100,
  },
  headingContainer: {
    flex: '1 1 auto',
  },
});

interface Props {
  children?: React.ReactNode;
  className?: string;
  heading: string;
  subheading?: string;
}

export const Header = ({ className, children, heading, subheading }: Props) => {
  const { setIsMenuOpen } = useUiStore();
  const handleMenuToggle = () => setIsMenuOpen(true);

  return (
    <div className={classes(css.container, className)}>
      <ButtonIcon className={css.menuToggler} icon={<MenuIcon />} size="s" type="white" onClick={handleMenuToggle} />
      <div className={css.headingContainer}>
        <h1 className={css.heading}>{heading}</h1>
        {subheading && <div className={css.subheading}>{subheading}</div>}
      </div>
      {children}
    </div>
  );
};
